import { useGetUserQuery } from "../redux/api/user";
import { useEffect, useState } from "react";

const UserDetailsHeader = () => {
  const data = useGetUserQuery();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (data.isSuccess) {
      setUser(data.data);
    }
  }, [data]);

  return (
    <div
      style={{
        color: "white",
        display: "flex",
        paddingLeft: "50px",
        paddingTop: "128px",
      }}
    >
      {user ? (
        <div>
          <h1
            style={{
              color: "white",
              fontSize: "2.5rem",
            }}
          >
            Hey, {user.nickname?.charAt(0).toUpperCase() + user.nickname?.slice(1)}!
          </h1>
          <div
            className="rolling-text"
            style={{
              width: "25vw",
              height: "5vh",
              color: "var(--dark-green-color)",
            }}
          >
            <span>Explore Data</span>
            <span>Deliver Insights</span>
            <span>Transform Growth</span>
            <span>Make It Happen!</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default UserDetailsHeader;
